const DX_TRACE_PATH = "M 69.11 43.09 L 58.15 30.81 L 56.39 25.22 L 53.95 21.18 L 48.31 16.12 L 42.41 13.34 L 34.96 11.80 L 0.49 11.57 L 0.01 11.25 L 0.03 0.38 L 35.27 0.25 L 46.75 2.49 L 55.45 6.47 L 62.93 12.80 L 67.09 18.70 L 68.97 22.74 L 70.81 31.12 L 70.53 37.95 L 69.11 43.09 Z M 94.26 79.59 L 86.19 78.74 L 80.91 76.53 L 77.49 74.09 L 71.91 68.37 L 47.07 38.39 L 40.86 32.31 L 37.44 30.45 L 33.09 29.22 L 25.02 28.56 L 14.05 28.95 L 14.24 62.17 L 0.18 75.97 L 0.00 22.42 L 34.02 22.06 L 39.61 22.57 L 44.89 23.87 L 50.48 26.44 L 55.76 30.45 L 69.11 45.56 L 90.54 26.36 L 94.57 24.20 L 99.85 23.21 L 97.99 25.62 L 72.59 49.44 L 97.19 78.94 L 97.06 79.44 L 94.26 79.59 Z M 29.68 82.07 L 0.09 82.04 L 5.15 75.37 L 11.36 71.66 L 18.19 70.44 L 33.09 69.72 L 38.68 68.43 L 43.96 66.27 L 48.62 63.25 L 52.36 59.69 L 57.31 51.97 L 65.86 62.17 L 63.93 65.90 L 60.80 69.62 L 51.72 76.56 L 41.17 80.61 L 29.68 82.07 Z";

export const DxDrawMark = ({ size = 44, className = "", testid = "dx-draw-mark" }) => (
  <span
    className={`dx-draw relative inline-block ${className}`}
    style={{ width: size, height: size }}
    data-testid={testid}
    aria-hidden="true"
  >
    <svg viewBox="0 0 100 100" width={size} height={size} className="block">
      <path
        d={DX_TRACE_PATH}
        pathLength={1}
        fill="none"
        stroke="#002B5B"
        strokeWidth={1.6}
        strokeLinejoin="round"
        strokeLinecap="round"
        className="dx-trace"
      />
    </svg>
    <img
      src="/doclyx-dx-mark.png"
      alt=""
      draggable={false}
      className="dx-mark-img absolute select-none pointer-events-none"
      style={{ inset: "-6.9%", width: "113.8%", height: "113.8%" }}
    />
  </span>
);
